/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Crop_Upper_ThirdInputs */



/**
* | output |
* | --- |
* | "Upper Third" |
*
* @param {Ocr_Crop_Upper_ThirdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_crop_upper_third = /** @type {((inputs?: Ocr_Crop_Upper_ThirdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Crop_Upper_ThirdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tiers supérieur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Oberes Drittel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Terzo superiore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Верхняя треть")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tercio superior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("上三分之一")
	if (locale === "ja") return /** @type {LocalizedString} */ ("上部3分の1")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऊपरी तीसरा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Terço superior")
	return /** @type {LocalizedString} */ ("Upper Third")
});